
import React, { useState } from "react";
import ActionButton from "../../components/ActionButton";
import { Link } from "react-router-dom";
import { FiEdit } from "react-icons/fi";
import DashboardLayout from "../../components/DashboardLayout";
import DashboardCard from "../../components/DashboardCard";
import { LIGHT_BLUE_COLOR } from "../../constants";
import { MdOutlineArrowBackIosNew } from "react-icons/md";
import { useForm } from "react-hook-form";
import ShowErrorAlert from "../../components/ErrorAlert";
import { extractErrorMessage } from "../../utils";
import axios from "axios";
import { BASE_URL } from "../../constants";
import { useSelector } from "react-redux";
import { ClipLoader } from "react-spinners";
import DashboardHeading from "../../components/DashboardHeading";
import Label from "../../components/Label";
import CustomInput from "../../components/CustomInput";
import ConfigurationsHeader from "./ConfigurationsHeader";

const AddDocumentType = () => {
    const {
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm({
        values: {
            type: "",
        },
    });

    // Redux Store
    const {
        auth: {
            token,
            user: { _id: userId },
        },
    } = useSelector((state) => state);

    // State Variables
    const [loading, setLoading] = useState(false);

    async function addDocumentTypeReq(body) {
        setLoading(true);
        try {
            await axios.post(`${BASE_URL}/users/${userId}/documentTypes`, body, {
                headers: {
                    Authorization: token,
                },
            });
            setLoading(false);
            reset();
        } catch (err) {
            setLoading(false);
            console.log(err);
            ShowErrorAlert(extractErrorMessage(err));
        }
    }

    function onSubmit(data) {
        addDocumentTypeReq(data);
    }

    return (
        <DashboardLayout>
            <ConfigurationsHeader />
            <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="flex justify-between align-center">
                        <div className="flex align-center">
                            <Link to="/admins/configurations/documentTypes">
                                <MdOutlineArrowBackIosNew size={20} />
                            </Link>
                            <DashboardHeading>Add Document Type</DashboardHeading>
                        </div>
                        <ActionButton type="submit" disabled={loading}>
                            {loading ? <ClipLoader color="black" size={20} /> : "Add"}
                        </ActionButton>
                    </div>
                    {/* form starts here */}
                    <DashboardCard>
                    <div key={"type"} className="mt-3">
                                    <Label required={true}>{"Type"}</Label>
                                    <CustomInput
                                        name={"type"}
                                        type={"text"}
                                        control={control}
                                        rules={{required: true}}
                                        errors={errors}
                                        errorText={"Type field is required"}
                                    />
                                </div>
                    </DashboardCard>
                </form>
            </DashboardCard>
            {/* <DashboardCard backgroundColor={LIGHT_BLUE_COLOR}>
                <div style={{display: "flex", flexDirection: "row"}}>
                <span style={{fontSize: "32px"}}>OR</span>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/documentTypes"  >
                <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                    <FiEdit color="white" size={20} className="me-2" />
                    <small>All Document Types</small>
                </ActionButton></Link>
                <Link style={{width: "fit-content", marginLeft: "24px"}} to="/admins/configurations/updateDocumentType"  >
                <ActionButton style={{ height: "55px" }} className={"flex-shrink-1"}>
                    <FiEdit color="white" size={20} className="me-2" />
                    <small>Update Document Type</small>
                </ActionButton></Link>
                </div>
            </DashboardCard> */}
        </DashboardLayout>

    )
}

export default AddDocumentType;